import React, { useEffect } from "react";
import Header from "../Header/Header";
import Main from "../Main/Main";
import { Link } from "react-router-dom";
import PageTitleServices from "./PageTitleServices";
import ServicesSectionWeb from "./ServicesSectionWeb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import Footer from "../Footer/Footer";
import { useTranslation } from "react-i18next";

function ServicesWeb() {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = t("services");
  }, [t]);

  return (
    <>
      <Header />
      <Main>
        <PageTitleServices />
        <ServicesSectionWeb />
      </Main>
      <Footer />
      <Link
        to="#"
        id="scroll-top"
        className="scroll-top d-flex align-items-center justify-content-center"
      >
        <FontAwesomeIcon icon={faArrowUp} />
      </Link>
    </>
  );
}

export default ServicesWeb;
